export const replaceNewLinesWithLineBreaks = (textToReplace: string) => {
  const breakTag = '<br />'

  return (textToReplace + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  )
}
